import { useQuery } from '@tanstack/react-query';
import { mcpHealthQueryOptions } from './mcpHealthQuery';

/**
 * On-demand health check for an installed MCP. Runs on mount and exposes `refetch` for the manual
 * refresh button. Shares its query config (and therefore its cache) with the composer's status
 * hook via {@link mcpHealthQueryOptions}.
 */
export const useTestMcpConnection = (mcpCatalogId: string) =>
  useQuery(mcpHealthQueryOptions(mcpCatalogId));
